import { MedicalService } from "@/clients/services/MedicalService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetAllergyOptions = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.ALLERGY_OPTIONS],
    queryFn: async () => {
      const { data } =
        await MedicalService.getAllergyOptionsApiV1MedicalAllergyOptionsGet();
      return data;
    },
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
